export default __webpack_public_path__ + "static/media/banner1.334c7283.jpg";